import React from 'react';
import { useTranslation } from 'react-i18next';

const steps = [
  { icon: 'bi-sliders',             num: 1, titleKey: 'indica_preferencias', descKey: 'indica_preferencias_desc' },
  { icon: 'bi-cpu',                 num: 2, titleKey: 'ia_analiza',          descKey: 'ia_analiza_desc' },
  { icon: 'bi-file-earmark-text',   num: 3, titleKey: 'recibe_plan',         descKey: 'recibe_plan_desc' },
  { icon: 'bi-pencil-square',       num: 4, titleKey: 'personalizalo',       descKey: 'personalizalo_desc' },
];

function ComoFuncionaSection() {
  const { t } = useTranslation();
  return (
    <>
      <div className="section-header-modern">
        <h2>{t('como_funciona')}</h2>
      </div>
      <div className="cf-grid">
        {steps.map(({ icon, num, titleKey, descKey }) => (
          <div key={num} className="cf-card">
            <div className="cf-icon-wrap">
              <span className="cf-number">{num}</span>
              <div className="cf-icon">
                <i className={`bi ${icon}`}></i>
              </div>
            </div>
            <h3 className="cf-title">{t(titleKey)}</h3>
            <p className="cf-desc">{t(descKey)}</p>
          </div>
        ))}
      </div>
    </>
  );
}

export default ComoFuncionaSection;
